import { useEffect } from "react";

const EMAIL_INPUT_SELECTOR = [
  'input[type="email"]',
  'input[name*="email" i]',
  'input[id*="email" i]',
].join(",");

/** Login/signup flows where saved email autofill is intentional. */
const shouldAllowBrowserEmailAutofill = (input: HTMLInputElement) => {
  const path = window.location.pathname;
  if (path === "/" || path === "/login" || path === "/register") return true;
  if (/forgotpassword|forgot-password/i.test(path)) return true;

  const ac = (input.getAttribute("autocomplete") || "").toLowerCase();
  if (ac === "username" || ac === "email") return true;

  return !!input.closest("[data-allow-email-autocomplete]");
};

const disableEmailAutocomplete = (root: ParentNode = document) => {
  root.querySelectorAll<HTMLInputElement>(EMAIL_INPUT_SELECTOR).forEach((input) => {
    if (shouldAllowBrowserEmailAutofill(input)) return;

    input.setAttribute("autocomplete", "new-password");
    input.setAttribute("autocorrect", "off");
    input.setAttribute("autocapitalize", "off");
    input.setAttribute("spellcheck", "false");
    input.setAttribute("data-lpignore", "true");
    input.setAttribute("data-1p-ignore", "true");
    input.setAttribute("data-bwignore", "true");
  });
};

export default function EmailAutocompleteGuard() {
  useEffect(() => {
    disableEmailAutocomplete();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            if (node.matches(EMAIL_INPUT_SELECTOR)) {
              disableEmailAutocomplete(node.parentElement || document);
            } else {
              disableEmailAutocomplete(node);
            }
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
